import React from 'react'
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CircleIcon from '@mui/icons-material/Circle';
import { useSymbolPrices } from '../../../context/WebSocketContext';

const WatlistArrow = ({ symbolId }) => {
    const row = useSymbolPrices()[symbolId];
    // const row = symbols[symbolId];
    return (
        <>
            {
                row?.bidColor === 'up' ?
                    <ArrowDropUpIcon sx={{ color: "green", fontSize: "25px", marginRight: "2px" }} /> :
                    row?.bidColor === 'down' ? <ArrowDropDownIcon sx={{ color: "red", fontSize: "25px", marginRight: "2px" }} /> : <CircleIcon sx={{ color: "#aaa", fontSize: "8px", marginRight: "10px", marginLeft: '7px' }} />
            }
        </>
        
    )
}

export default WatlistArrow